import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import { StoresContext } from '@App/contexts'
import { getGroupWorks } from '@App/stores/search/work/work-merge-bulk-action-store'
import WorkMergeRequestGroup from '@Scenes/RightsholderScene/WorkMerge/WorkMergeRequestGroup'
import './index.scss'

const WorkMergeRequestReview = () => {
    const { catalogSearchBulkActionStore } = useContext(StoresContext)
    const groups = catalogSearchBulkActionStore.confirmedMergeGroups

    return (
        <div className="work-merge-request-review">
            <div className="work-merge-panel-header">
                <h5>Review Merge Request</h5>
                <p>Review the details below to confirm the merged work is correct before you submit your request.</p>
            </div>
            <div className="work-merge-panel-list">
                {groups.map((group, index) => {
                    const { primaryWork, secondaryWorks } = getGroupWorks(group)
                    if (!primaryWork) {
                        return null
                    }

                    return (
                        <WorkMergeRequestGroup
                            key={group.id}
                            heading={`Request ${index + 1} of ${groups.length}`}
                            primaryWork={primaryWork}
                            secondaryWorks={secondaryWorks}
                            reason={group.reason}
                            onRemove={() => catalogSearchBulkActionStore.removeConfirmedGroup(group.id)}
                        />
                    )
                })}
            </div>
        </div>
    )
}

export default observer(WorkMergeRequestReview)
